module.exports = __webpack_public_path__ + "img/entertainment-end-tables.f48ad4f.jpg";